import { createContext } from 'react';

export const Statuses = Object.freeze({
  maintenance: 'maintenance',
  ok: 'ok',
  pending: 'pending',
} as const);

export type StatusContextType = {
  status: (typeof Statuses)[keyof typeof Statuses];
};

export const StatusContext = createContext<StatusContextType>({
  status: Statuses.pending,
});
